import { change, Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import {
  isInteger,
  normalizeDecimal,
  normalizeRate,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderDateField,
  renderTextArea,
  renderTextField,
} from '../../../../components/reduxFields';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { CheckPayerServiceCodeModifierDependency, SaveSinglePayerServiceCode, getAllPayerCptCodeByPayerId, GetMasterServiceCodeById, getPayerServiceCodeById, resetServiceCodeDetails } from '../../actions';
import { isEmptyObject, showNormalizedRate, AMEGO, VIP, AMEGOFL, JOYSCAPE, STEPUPOUTPATIENT, STEPUPFAMILYSERVICES, ADASTRA } from '../../../../actions/utilAction';
import { CancelButton, SubmitButtonModal } from '../../../../components/buttons';
import SmallLoader from '../../../../img/small-loader.gif';
import moment from 'moment';
import _ from 'lodash';

const validate = (values) => {
  const error = {};
  if (!values.unitDuration) {
    error.unitDuration = 'Please enter unit duration';
  }
  if (!values.ruleID) {
    error.ruleID = 'Please select a Rule';
  } else if (!Number.isInteger(values.ruleID)) {
    error.ruleID = 'Please select an option';
  }
  if (!values.unitTypeID) {
    error.unitTypeID = 'Please select a unit type';
  } else if (!Number.isInteger(values.unitTypeID)) {
    error.unitTypeID = 'Please select an option';
  }
  if (!values.serviceCodeId) {
    error.serviceCodeId = 'Please select Service code';
  }
  if (!values.ratePerUnit) {
    error.ratePerUnit = 'Please enter rate per unit';
  }
  if (values.modifierModel && values.modifierModel.length) {
    const modifierModelArrayErrors = [];
    const modifiersArray = values.modifierModel.map((obj) => obj.id);
    values.modifierModel.forEach((modifierObj, modifierIndex) => {
      const modifierErrors = {};
      if (modifierObj && modifierObj.id) {
        let isModifierIndex = (modifiersArray || []).findIndex((obj) => (obj || '').toLowerCase() === (modifierObj.id || '').toLowerCase());
        if (isModifierIndex > -1 && isModifierIndex !== modifierIndex) {
          modifierErrors.id = 'Please select another modifier.';
          modifierModelArrayErrors[modifierIndex] = modifierErrors;
        }
        if (!modifierObj.rate) {
          modifierErrors.rate = 'Please enter rate.';
          modifierModelArrayErrors[modifierIndex] = modifierErrors;
        }
      }
      if (modifierObj && modifierObj.rate && !modifierObj.id) {
        modifierErrors.id = 'Please select modifier.';
        modifierModelArrayErrors[modifierIndex] = modifierErrors;
      }
      return modifierErrors;
    });
    if (modifierModelArrayErrors.length) {
      error.modifierModel = modifierModelArrayErrors;
    }
  }
  return error;
};

class CptCodeModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      cptCode: null,
      newCptList: [],
      serviceCodeID: null,
      modifierList: [],
      modifierModel: [],
      payerRateModel: [],
      startDate: [],
      endDate: [],
    };
  }

  componentWillMount() {
    if (this.props.payerServiceCodeID) {
      this.props.getPayerServiceCodeById(this.props.payerServiceCodeID);
    }
    this.props.getAllPayerCptCodeByPayerId(this.props.payerId);
  }

  fillMasterModifiers(nextProps) {
    if (nextProps.masterServiceCodeDetails) {
      let modifierList = [];
      let modifierModel = [];

      nextProps.masterServiceCodeDetails.data.modifierModel.filter((data, i) => {
        modifierList.push({
          'id': data.modifierID ? data.modifierID + '_' + data.key : 0,
          'value': data.modifier,
          'key': data.key,
          'rate': showNormalizedRate(data.rate),
          'modifierId': data.modifierID ? data.modifierID : 0,
          'isUsedModifier': data.isUsedModifier ? 1 : 0,
        });

        return modifierList;
      });


      nextProps.masterServiceCodeDetails.data.modifierModel.filter((data, i) => {
        modifierModel.push({
          'id': data.modifierID ? data.modifierID : 0,
          'modifier': data.modifier,
          'key': data.key,
          'rate': showNormalizedRate(data.rate),
          'modifierId': data.modifierID ? data.modifierID : 0,
          'isUsedModifier': data.isUsedModifier ? 1 : 0,
        });

        return modifierModel;
      });

      this.setState({ modifierList: modifierList, modifierModel: modifierModel });
    }
  }

  componentWillReceiveProps(nextProps) {
    // on ESC key press close Dailog ...

    if (!this.props.payerServiceCodeID) {
      this.fillMasterModifiers(nextProps);
    }

    if (nextProps.payerServiceCodeDetailsData && this.props.payerServiceCodeDetailsData !== nextProps.payerServiceCodeDetailsData) {
      let modifierList = [];
      let modifierModel = [];

      nextProps.payerServiceCodeDetailsData.data.payerModifierModel.filter((data, i) => {
        modifierList.push({
          'id': data.id ? data.id + '_' + data.key : 0,
          'value': data.modifier,
          'key': data.key,
          'rate': showNormalizedRate(data.rate),
          'modifierId': data.id ? data.id : 0,
          'isUsedModifier': data.isUsedModifier,
        });
        return modifierList;
      });

      nextProps.payerServiceCodeDetailsData.data.payerModifierModel.filter((data, i) => {
        modifierModel.push({
          'id': data.id ? data.id : 0,
          'modifier': data.modifier,
          'key': data.key,
          'rate': showNormalizedRate(data.rate),
          'modifierId': data.id ? data.id : 0,
          'isUsedModifier': data.isUsedModifier,
        });
        return modifierModel;
      });
      this.setState({ modifierList: modifierList, modifierModel: modifierModel });
    }

    if (nextProps.payerServiceCodeDetailsData && nextProps.payerServiceCodeDetailsData.data && nextProps.payerServiceCodeDetailsData.data.payerRateModel) {      
      let startDate = this.state.startDate;
      let endDate = this.state.endDate;
      (nextProps.payerServiceCodeDetailsData.data.payerRateModel || []).forEach((obj, index) => {
          
          if(obj.startDate != undefined)
          {
            _.update(startDate, `[${index}]`, function (n) {
                return moment(obj.startDate).format('MM-DD-YYYY');
            });
          
            this.props.dispatch(change('CptCodeModal', `payerRateModel[${index}].startDate`, moment(obj.startDate).format('MM-DD-YYYY') || null));
          }

          if(obj.endDate != undefined)
          {
            _.update(endDate, `[${index}]`, function (n) {
                return moment(obj.endDate).format('MM-DD-YYYY');
            });

            this.props.dispatch(change('CptCodeModal', `payerRateModel[${index}].endDate`, moment(obj.endDate).format('MM-DD-YYYY') || null));
          }

          this.props.dispatch(change('CptCodeModal', `payerRateModel[${index}].id`, obj.id || 0));
        
          this.props.dispatch(change('CptCodeModal', `payerRateModel[${index}].payerServiceCodeId`,obj.payerServiceCodeId || 0));
        
          this.props.dispatch(change('CptCodeModal', `payerRateModel[${index}].rate`,showNormalizedRate(obj.rate)|| 0.00));
        
          // this.props.dispatch(change('CptCodeModal', `payerRateModel[${index}].modifier1`, obj.modifier1 || ''));
        
          // this.props.dispatch(change('CptCodeModal', `payerRateModel[${index}].modifier2`, obj.modifier2 || ''));
        
          // this.props.dispatch(change('CptCodeModal', `payerRateModel[${index}].modifier3`, obj.modifier3 || ''));
        
          // this.props.dispatch(change('CptCodeModal', `payerRateModel[${index}].modifier4`, obj.modifier4 || ''));
      });

      this.setState({ startDate: startDate, endDate: endDate });
   
  }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleClose = () => {
    if (this.state.open !== undefined && this.state.open === true) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  handleNewRequest = (input, selectedRecord) => {
    if (input.name === 'serviceCodeId') {
      input.onChange(selectedRecord.value);
      // let cptDetail = null;
      this.setState({ cptCode: selectedRecord.label });
      if (selectedRecord.value)
        this.props.GetMasterServiceCodeById(selectedRecord.value);
      else
        this.props.resetServiceCodeDetails();
      // let propsData = this.props.masterServiceCode.slice(0);
      // propsData.filter((data) => {
      //   if ((data.id === selectedRecord.value) && (data.serviceCode === selectedRecord.label)) {
      //     cptDetail = data;
      //   }
      //   return cptDetail;
      // });
      // console.log('cptDetail............',cptDetail);
      // if (cptDetail) {
      //   this.props.dispatch(change('CptCodeModal', 'description', cptDetail.description));
      //   this.props.dispatch(change('CptCodeModal', 'unitDuration', cptDetail.unitDuration));
      //   this.props.dispatch(change('CptCodeModal', 'unitTypeID', cptDetail.unitTypeID));
      //   this.props.dispatch(change('CptCodeModal', 'ratePerUnit', cptDetail.ratePerUnit));
      //   this.props.dispatch(change('CptCodeModal', 'ruleID', cptDetail.ruleID));
      //   this.props.dispatch(change('CptCodeModal', 'isBillable', cptDetail.isBillable));
      //   this.props.dispatch(change('CptCodeModal', 'isRequiredAuthorization', cptDetail.isRequiredAuthorization));
      // } else {
      //   this.props.dispatch(change('CptCodeModal', 'description', null));
      //   this.props.dispatch(change('CptCodeModal', 'unitDuration', null));
      //   this.props.dispatch(change('CptCodeModal', 'unitTypeID', null));
      //   this.props.dispatch(change('CptCodeModal', 'ratePerUnit', null));
      //   this.props.dispatch(change('CptCodeModal', 'ruleID', null));
      //   this.props.dispatch(change('CptCodeModal', 'isBillable', false));
      //   this.props.dispatch(change('CptCodeModal', 'isRequiredAuthorization', false));
      // }

    }

    if (input.name === 'unitTypeID') {
      input.onChange(selectedRecord.value);
    } else if (input.name === 'ruleID') {
      input.onChange(selectedRecord.value);
    } else {
      input.onChange(selectedRecord.id);
    }
  };

  handleChangeModifier = (input, selectedRecord, i) => {
    input.onChange(selectedRecord.value);
    let rate = null;
    if (selectedRecord && selectedRecord.value) {
      let selectedRecordValue = selectedRecord.value.split('_')[0];
      this.setState({ serviceCodeID: parseInt(selectedRecordValue) });
      rate = this.state.modifierModel.filter((obj, index) => obj.id === parseInt(selectedRecordValue))[0].rate;
    }
    this.props.dispatch(change('CptCodeModal', `modifierModel[${i}].rate`, rate));
  }

  onSubmitHandler(formData) {
    let newFormData = {};
    // let dataFormat = {};
    if (!formData.isBillable) {
      formData.isBillable = false;
    }

    newFormData = {
      'payerId': this.props.payerId,
      'description': formData.description,
      'ratePerUnit': formData.ratePerUnit,
      'unitType': formData.unitTypeID,
      'serviceCodeId': formData.serviceCodeId,
      'unitDuration': formData.unitDuration,
      'ruleID': formData.ruleID,
      'isBillable': formData.isBillable ? formData.isBillable : false,
      'isRequiredAuthorization': formData.isRequiredAuthorization ? formData.isRequiredAuthorization : false,
      'authorizedUnits': formData.authorizedUnits ? formData.authorizedUnits : null,      
      'isAllowedAmountSameAsBilledAmount': formData.isAllowedAmountSameAsBilledAmount ? formData.isAllowedAmountSameAsBilledAmount : false,      
      // 'isActive': formData.isActive ? formData.isActive : false,
    };

    newFormData.id = formData.payerServiceCodeID ? formData.payerServiceCodeID : 0;

    // ---------------Start Save to modifierModel in payer service code------------

    let listModifiers = [];
    if (formData.modifierModel && formData.modifierModel.length > 0 && !isEmptyObject(formData.modifierModel[0])) { //  Save Tags

      formData.modifierModel.filter((data, i) => {
        if (data.id && data.rate) {
          let modifierId = data.id.split('_')[0];
          let modifier = this.state.modifierModel.filter((obj, index) => obj.id === parseInt(modifierId))[0].modifier;
          let key = this.state.modifierModel.filter((obj, index) => obj.id === parseInt(modifierId))[0].key;
          let currentModifier = {
            'id': key === 'MSCM' ? 0 : this.props.initialValues && this.props.initialValues.payerServiceCodeID === 0 ? 0 : modifierId ? parseInt(modifierId) : 0,
            'payerServiceCodeId': this.props.initialValues && this.props.initialValues.payerServiceCodeID === 0 ? 0 : this.props.initialValues.payerServiceCodeID,
            'modifier': modifier,
            'rate': showNormalizedRate(data.rate),
          };
          listModifiers.push(currentModifier);
        }
        return listModifiers;
      });
    }
    newFormData.payerModifierModel = listModifiers;
    // ---------------End Save to modifierModel in payer service code------------


    // ---------------Start Save to payerRateModel in payer service code------------

    let listRateModel = [];
    if (formData.payerRateModel && formData.payerRateModel.length > 0 && !isEmptyObject(formData.payerRateModel[0])) { //  Save Tags
      
      formData.payerRateModel.filter((data, i) => {
        if (data.rate) {          
          let currentRate = {
            'id': this.props.initialValues && this.props.initialValues.payerServiceCodeID === 0 ? 0 : data.id ? data.id : 0,
            'payerServiceCodeId': this.props.initialValues && this.props.initialValues.payerServiceCodeID === 0 ? 0 : this.props.initialValues.payerServiceCodeID,
            'startDate':  data.startDate ? moment(data.startDate).format('YYYY-MM-DD') + 'T' + moment(data.startDate).format('HH:mm:ss') : null,
            'endDate':  data.endDate ? moment(data.endDate).format('YYYY-MM-DD') + 'T' + moment(data.endDate).format('HH:mm:ss') : null,
            'rate': data.rate ? showNormalizedRate(data.rate) : 0,
            'modifier1': data.modifier1 ? data.modifier1 : '',
            'modifier2': data.modifier2 ? data.modifier2 : '',
            'modifier3': data.modifier3 ? data.modifier3 : '',
            'modifier4': data.modifier4 ? data.modifier4 : '',         

          };

          listRateModel.push(currentRate);
        }
        return listRateModel;
      });
    }
    newFormData.payerRateModel = listRateModel;
    // ---------------End Save to payerRateModel in payer service code------------

    //console.log('formData..........', JSON.stringify([newFormData]));
    this.props.SaveSinglePayerServiceCode(newFormData);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  addModifierRow = () => { };
  removeModifierRow = (i) => { };
  // removeModifierRowFromDatabase = (i, modifierId) => { };

  renderModifiersTemplate = ({ fields }) => {
    this.addModifierRow = (e) => {
      fields.push({});
    };

    this.removeModifierRow = (i, e) => {
      fields.remove(i);
    };

    // this.removeModifierRowFromDatabase = (i, modifierId) => {
    //   this.props.CheckPayerServiceCodeModifierDependency(modifierId);
    //   if (this.props.modifierStatus && this.props.modifierStatus.statusCode === 200) {
    //     fields.remove(i);
    //   }
    // };

    return (
      <div>
        {fields.map((modifierModel, i) =>
          <div id="currentDiv" className="row" key={i}>
            <div className="col-sm-4 mt-35">
              <Field
                name={`modifierModel[${i}].id`}
                label="Modifier"
                handleNewRequest={(e, value) => this.handleChangeModifier(e, value, i)}
                options={this.state.modifierList}
                disabled={this.props.initialValues && this.props.initialValues.modifierModel && this.props.initialValues.modifierModel[i] && this.props.initialValues.modifierModel[i].isUsedModifier ? true : false}
                component={renderAutoCompleteSingleSelect}
              />
            </div>
            <div className="col-sm-4 pdl-40">
              <Field
                name={`modifierModel[${i}].rate`}
                type="text"
                maxLength="8"
                label="Rate Per Unit ($)"
                component={renderTextField}
                normalize={normalizeRate}
              />

              {fields.length === i + 1 ?
                <div>
                  {this.props.initialValues && this.props.initialValues.modifierModel && this.props.initialValues.modifierModel[i] && this.props.initialValues.modifierModel[i].isUsedModifier === false && fields.length > 1 ?
                    <button className="additem removeitem"
                      onClick={this.removeModifierRow.bind(this, i)}
                      title="Remove Service Codes"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                    : ''}
                  <button className="additem" title="Add Service Codes" onClick={(e) => this.addModifierRow()} type="button">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>
                </div>
                :
                <div>
                  {this.props.initialValues && this.props.initialValues.modifierModel && this.props.initialValues.modifierModel[i] && this.props.initialValues.modifierModel[i].isUsedModifier === false ?
                    <button className="additem"
                      onClick={this.removeModifierRow.bind(this, i)}
                      title="Remove Service Codes"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                    : ''}
                </div>
              }
            </div>
          </div>

        )
        }
      </div>
    );
  };

  onDateChange = (input, value, i, type) => {

    input.onChange(moment(value).format());
    if(type === 'FROM DATE')
    {
        let startDate = this.state.startDate;

        _.update(startDate, `[${i}]`, function (n) {
          return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });

        this.setState({ startDate: startDate }, ()=>{                  
          document.getElementsByName(`payerRateModel[${i}].endDate`)[0].focus();           
      });
    }
    else if(type === 'TO DATE')
    {
        let endDate = this.state.endDate;

        _.update(endDate, `[${i}]`, function (n) {
          return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });

        this.setState({ endDate: endDate }, ()=>{                  
          document.getElementsByName(`payerRateModel[${i}].startDate`)[0].focus();           
      });
    }
  }
  
  addRateRow = () => { };
  removeRateRow = (i) => { };
  // removeRateRowFromDatabase = (i, rateId) => { };

  renderRateTemplate = ({ fields }) => {
    this.addRateRow = (e) => {
      fields.push({});
    };

    this.removeRateRow = (i, e) => {
      fields.remove(i);
    };

     return (
      <div>
        {fields.map((payerRateModel, i) =>
          <div id="currentDiv" className="row" key={i}>
            <div className="col-sm-2">
                <Field
                    name={`payerRateModel[${i}].startDate`}
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.startDate[i] || null}
                    onDateChange={(input, value) => this.onDateChange(input, value, i, 'FROM DATE')}
                    openToYearSelection={true}
                    component={renderDateField} />
            </div>
            <div className="col-sm-2">
              <Field
                name={`payerRateModel[${i}].endDate`}
                placeholder="To Date"
                locale="en-US"
                selected={this.state.endDate[i] || null}
                onDateChange={(input, value) => this.onDateChange(input, value, i, 'TO DATE')}
                openToYearSelection={true}
                component={renderDateField} />
            </div>
            <div className="col-sm-2">
                <Field
                  name={`payerRateModel[${i}].rate`}
                  type="text"
                  maxLength="8"
                  label="Rate Per Unit ($)"
                  component={renderTextField}
                  normalize={normalizeRate}
                />
            </div>
            <div className="col-sm-1">
                <Field
                  name={`payerRateModel[${i}].modifier1`}
                  type="text"
                  maxLength="2"
                  label="Modifier 1"
                  component={renderTextField}                  
                />
            </div>
            <div className="col-sm-1">
                <Field
                  name={`payerRateModel[${i}].modifier2`}
                  type="text"
                  maxLength="2"
                  label="Modifier 2"
                  component={renderTextField}                  
                />
            </div>
            <div className="col-sm-1">
                <Field
                  name={`payerRateModel[${i}].modifier3`}
                  type="text"
                  maxLength="2"
                  label="Modifier 3"
                  component={renderTextField}                  
                />
            </div>
            <div className="col-sm-1">
                <Field
                  name={`payerRateModel[${i}].modifier4`}
                  type="text"
                  maxLength="2"
                  label="Modifier 4"
                  component={renderTextField}                  
                />
            </div>
            <div className="col-sm-2">
              {fields.length === i + 1 ?
                <div>
                  {fields.length > 1 ?
                    <button className="additem removeitem"
                      onClick={this.removeRateRow.bind(this, i)}
                      title="Remove Rate"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  : ''}
                  <button className="additem" title="Add Rate" onClick={(e) => this.addRateRow()} type="button">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>
                </div>
                :
                <div>
                  
                    <button className="additem"
                      onClick={this.removeRateRow.bind(this, i)}
                      title="Remove Rate"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  
                </div>
              }
            </div>
          </div>

        )
        }
      </div>
    );
  };

  render() {
    const { handleSubmit } = this.props;
    const actions = [
      <CancelButton className='mr-15' onTouchTap={this.handleClose} />
      ,
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />
      ,
    ];

    return (
      <Dialog className="custom_modal_new_appointment"
        title={this.props.payerServiceCodeID ? 'Edit Service Code' : 'Add Service Code'}
        modal={false}
        actions={actions}
        open={this.state.open}
        autoScrollBodyContent={true}>

        {this.props.loading_servicecodedetails ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null
        }

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                {!this.props.payerServiceCodeID ?
                  (<div className="col-sm-6 require mt-35">
                    <Field
                      name="serviceCodeId"
                      label="Service Code"
                      handleNewRequest={this.handleNewRequest}
                      options={this.props.masterServiceCodes}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>)
                  : (<div className="col-sm-6 require">
                    <Field
                      name="payerServiceCodeName"
                      label="Service Code"
                      disabled={true}
                      component={renderTextField}
                    />
                  </div>)}
                <div className="col-sm-6 col-md-6 require mt-35">
                  <Field
                    name="ruleID"
                    label="Rounding Rule"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterRoundingRules}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <Field
                    name="description"
                    type="text"
                    maxLength="450"
                    label="Description"
                    // normalize = {isValidNameWithSpace}
                    fullWidth={true}
                    component={renderTextArea} />
                  <small className="blackfont font12">{this.props.description ? 450 - this.props.description.length : 450} Characters remaining </small>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 require">
                  <Field
                    name="unitDuration"
                    type="text"
                    maxLength="3"
                    label="Unit Duration"
                    component={renderTextField}
                    normalize={isInteger}
                  />
                </div>
                <div className="col-sm-12 col-md-6 require mt-35" >
                  <Field
                    name="unitTypeID"
                    label="Unit Type"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.masterUnitType}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 require">
                  <Field
                    name="ratePerUnit"
                    type="text"
                    maxLength="8"
                    label="Rate Per Unit ($)"
                    component={renderTextField}
                    normalize={normalizeDecimal}
                  />
                </div>
                {(this.props.agencyName.toUpperCase() === AMEGO || this.props.agencyName.toUpperCase() === AMEGOFL || this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === ADASTRA || this.props.agencyName.toUpperCase() === STEPUPFAMILYSERVICES || this.props.agencyName.toUpperCase() === STEPUPOUTPATIENT || this.props.agencyName.toUpperCase() === JOYSCAPE || this.props.agencyName.toUpperCase() === 'PLAYTHINKS') ? 
                <div className="col-sm-12 col-md-6">
                  <Field
                    name="authorizedUnits"
                    label="Authorized Units Per Day"
                    maxLength='2'
                    component={renderTextField}
                    normalize={isInteger}
                  />
                </div>
                : null}
              </div>
              <FieldArray name="modifierModel" component={this.renderModifiersTemplate} />
              
              <FieldArray name="payerRateModel" component={this.renderRateTemplate} />

              <div className="row">
                <div className="col-sm-3">
                  <Field className="mt38 mb0"
                    name="isBillable"
                    label="Billable"
                    component={renderCheckBox}
                  />
                </div>
                <div className="col-sm-3">
                  <Field className="mt38 mb0"
                    name="isRequiredAuthorization"
                    label="Required Authorization"
                    component={renderCheckBox}
                  />
                </div>
                <div className="col-sm-6">
                  <Field className="mt38 mb0"
                    name="isAllowedAmountSameAsBilledAmount"
                    label="Allowed Rate is the same as the Billed Rate"
                    component={renderCheckBox}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

const selector = formValueSelector('CptCodeModal');

function mapStateToProps(state, ownProps) {

  let initialValueData = {
    modifierModel: [{}],
    payerRateModel: [{}],
  };

  if (state.payer.masterServiceCodeDetails && state.payer.masterServiceCodeDetails.data) {

    initialValueData['serviceCodeId'] = state.payer.masterServiceCodeDetails.data.id;
    // initialValueData['payerServiceCodeID'] = state.payer.payerServiceCodeDetailsData && state.payer.payerServiceCodeDetailsData.data ? state.payer.payerServiceCodeDetailsData.data.id : 0;
    initialValueData['payerServiceCodeID'] = 0;
    initialValueData['ruleID'] = state.payer.masterServiceCodeDetails.data.ruleID;
    initialValueData['unitDuration'] = state.payer.masterServiceCodeDetails.data.unitDuration;
    initialValueData['unitTypeID'] = state.payer.masterServiceCodeDetails.data.unitTypeID;
    initialValueData['ratePerUnit'] = showNormalizedRate(state.payer.masterServiceCodeDetails.data.ratePerUnit);
    initialValueData['isBillable'] = state.payer.masterServiceCodeDetails.data.isBillable;
    initialValueData['description'] = state.payer.masterServiceCodeDetails.data.description;
    initialValueData['isRequiredAuthorization'] = state.payer.masterServiceCodeDetails.data.isRequiredAuthorization;
    initialValueData['authorizedUnits'] = state.payer.masterServiceCodeDetails.data.authorizedUnits || null;    
    initialValueData['isAllowedAmountSameAsBilledAmount'] = state.payer.masterServiceCodeDetails.data.isAllowedAmountSameAsBilledAmount;
    

    // initialValueData['modifierModel'] = state.payer.masterServiceCodeDetails.data && state.payer.masterServiceCodeDetails.data.modifierModel && state.payer.masterServiceCodeDetails.data.modifierModel.length > 0  ? state.payer.masterServiceCodeDetails.data.modifierModel : [{}];
    // initialValueData['modifierModel'] = [{}];
  } else if (state.payer.get_payer_service_code_by_id && state.payer.get_payer_service_code_by_id.data) {
    initialValueData = {
      'serviceCodeId': state.payer.get_payer_service_code_by_id.data.serviceCodeId,
      'payerServiceCodeName': ownProps.payerServiceCodeName,
      'payerServiceCodeID': state.payer.get_payer_service_code_by_id.data.id,
      'ruleID': state.payer.get_payer_service_code_by_id.data.ruleID,
      'unitDuration': state.payer.get_payer_service_code_by_id.data.unitDuration,
      'unitTypeID': state.payer.get_payer_service_code_by_id.data.unitType,
      'ratePerUnit': showNormalizedRate(state.payer.get_payer_service_code_by_id.data.ratePerUnit),
      'isBillable': state.payer.get_payer_service_code_by_id.data.isBillable,
      'description': state.payer.get_payer_service_code_by_id.data.description,
      'isRequiredAuthorization': state.payer.get_payer_service_code_by_id.data.isRequiredAuthorization,
      'authorizedUnits': state.payer.get_payer_service_code_by_id.data.authorizedUnits,      
      'isAllowedAmountSameAsBilledAmount': state.payer.get_payer_service_code_by_id.data.isAllowedAmountSameAsBilledAmount,      
    };
    // initialValueData['modifierModel'] = [{}];
  }
  let masterServiceCodes = [];
  if (state.payer.payerAllCptCodesByPayer && state.payer.payerAllCptCodesByPayer.data) {
    masterServiceCodes = state.payer.payerAllCptCodesByPayer.data;
  }
  if (state.payer.get_payer_service_code_by_id && state.payer.get_payer_service_code_by_id.data && state.payer.get_payer_service_code_by_id.data.payerModifierModel && state.payer.get_payer_service_code_by_id.data.payerModifierModel.length > 0) {
    let modifiers = [];
    state.payer.get_payer_service_code_by_id.data.payerModifierModel.filter((data, i) => {
      if (data.key === 'PSCM') {
        modifiers.push({
          'id': data.id ? data.id + '_' + data.key : 0,
          'value': data.modifier,
          'key': data.key,
          'rate': data.rate && showNormalizedRate(data.rate),
          'modifierId': data.id ? data.id : 0,
          'isUsedModifier': data.isUsedModifier,
        });
      }
      return modifiers;
    });
    initialValueData['modifierModel'] = modifiers && modifiers.length > 0 ? modifiers : [{}];
  }


  let payerRateModel = [];
  if (state.payer.get_payer_service_code_by_id && state.payer.get_payer_service_code_by_id.data && state.payer.get_payer_service_code_by_id.data.payerRateModel && state.payer.get_payer_service_code_by_id.data.payerRateModel.length > 0) {
   // console.log('state.payer.get_payer_service_code_by_id.data.payerRateModel.............',state.payer.get_payer_service_code_by_id)
 
    state.payer.get_payer_service_code_by_id.data.payerRateModel.filter((data, i) => {
     
      payerRateModel.push({
          'id': data.id ? data.id : 0,
          'payerServiceCodeId': data.payerServiceCodeId,
          'startDate': data.startDate,
          'endDate': data.endDate,
          'rate': data.rate && showNormalizedRate(data.rate),
          'modifier1': data.modifier1 ? data.modifier1 : '',
          'modifier2': data.modifier2 ? data.modifier2 : '',
          'modifier3': data.modifier3 ? data.modifier3 : '',
          'modifier4': data.modifier4 ? data.modifier4 : '',         
        });
      
      return payerRateModel;
    });
    initialValueData['payerRateModel'] = payerRateModel && payerRateModel.length > 0 ? payerRateModel : [{}];
  } else {
    initialValueData['payerRateModel'] = [{}];
  }

  // initialValueData = {   
  //   payerRateModel: payerRateModel,
  // };

//console.log('initialValueData.......',initialValueData)

  return {
    initialValues: initialValueData,
    // initialValues: ownProps.serviceCodeData ? {
    //   serviceCodeID: ownProps.serviceCodeData.serviceCodeID,
    //   unitDuration: ownProps.serviceCodeData.unitDuration,
    //   unitTypeID: ownProps.serviceCodeData.unitTypeID,
    //   ratePerUnit: showNormalizedRate(ownProps.serviceCodeData.ratePerUnit),
    //   isBillable: ownProps.serviceCodeData.isBillable,
    //   description: ownProps.serviceCodeData.description,
    //   ruleID: ownProps.serviceCodeData.ruleID,
    //   payerServiceCodeID: ownProps.serviceCodeData.payerServiceCodeID,
    //   isRequiredAuthorization: ownProps.serviceCodeData.isRequiredAuthorization,
    // } : {},
    masterServiceCode: state.payer.master_data.masterServiceCode,
    // payerCptCodesByPayer: state.payer.payerCptCodesByPayer,
    masterUnitType: state.payer.master_data.masterUnitType,
    masterRoundingRules: state.payer.master_data.masterRoundingRules,
    // activePayerInfo: state.payer.activePayerInfo,
    activePayerId: state.payer.activePayerId,
    unitTypeID: selector(state, 'unitTypeID'),
    ratePerUnit: selector(state, 'ratePerUnit'),
    unitDuration: selector(state, 'unitDuration'),
    description: selector(state, 'description'),
    ruleID: selector(state, 'ruleID'),
    loading_servicecodedetails: state.payer.loading_servicecodedetails,
    masterServiceCodeDetails: state.payer.masterServiceCodeDetails,
    payerServiceCodeDetailsData: state.payer.get_payer_service_code_by_id,
    modifierStatus: state.payer.serviceCodeModifierStatus,
    masterServiceCodes: masterServiceCodes,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}


CptCodeModal = reduxForm({
  form: 'CptCodeModal',
  validate,
  enableReinitialize: true,
})(CptCodeModal);

export default connect(mapStateToProps, { SaveSinglePayerServiceCode, getPayerServiceCodeById, CheckPayerServiceCodeModifierDependency, getAllPayerCptCodeByPayerId, GetMasterServiceCodeById, resetServiceCodeDetails })(CptCodeModal);



// WEBPACK FOOTER //
// ./src/modules/Payers/containers/payerModule/CptCodeModal.js